import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { Redirect } from 'react-router-dom';
import { withTheme } from 'styled-components';
import { Divider, Container, Icon, Tab } from 'semantic-ui-react';
import { defaultProps } from 'recompose';

import APP_PERMISSION from 'Util/permissions/permissionKeys';
import Menu from 'Containers/Menu';
import { GenRoute } from 'Util/Route';
import { Flex } from 'Components/Base';
import getConfig from 'Util/Config';

import OnlineCourseBatchHeader from '../../Components/OnlineCourseBatchHeader';
import ProductPreviewButton from '../../Components/ProductPreviewButton';
import {
  OnlineCourseOverviewEditor,
  OnlineCourseCategoriesEditor,
  OnlineCourseInstructorsEditor,
  OnlineCourseDetailsEditor,
  // TODO: OnlineCourseTableOfContentEditor is an incomplete route, see more details in component
  OnlineCourseTableOfContentEditor,
  OnlineCourseHighlightEditor,
  OnlineCourseRatingEditor,
  OnlineCourseBatchesEditor,
  OnlineCourseFAQEditor,
} from '../../Components/OnlineCourseBatchEditor';

const genMenu = (matchUrl) => {
  const menus = [
    {
      path: `${matchUrl}/overview`,
      title: 'Overview',
      private: true,
      exact: true,
      roles: [
        APP_PERMISSION.COMMON.ADMINISTRATOR,
        APP_PERMISSION.COMMON.MARKETER,
        APP_PERMISSION.ONLINE_COURSE.OVERVIEW.VIEW,
      ],
      route: OnlineCourseOverviewEditor,
    },
    {
      path: `${matchUrl}/categories`,
      title: 'Categories',
      private: true,
      exact: true,
      roles: [
        APP_PERMISSION.COMMON.ADMINISTRATOR,
        APP_PERMISSION.COMMON.MARKETER,
        APP_PERMISSION.ONLINE_COURSE.CATEGORIES.VIEW,
      ],
      route: OnlineCourseCategoriesEditor,
    },
    {
      path: `${matchUrl}/instructors`,
      title: 'Instructors',
      private: true,
      exact: true,
      roles: [
        APP_PERMISSION.COMMON.ADMINISTRATOR,
        APP_PERMISSION.COMMON.MARKETER,
        APP_PERMISSION.ONLINE_COURSE.INSTRUCTORS.VIEW,
      ],
      route: OnlineCourseInstructorsEditor,
    },
    {
      path: `${matchUrl}/details`,
      title: 'Details',
      private: true,
      exact: true,
      roles: [
        APP_PERMISSION.COMMON.ADMINISTRATOR,
        APP_PERMISSION.COMMON.MARKETER,
        APP_PERMISSION.ONLINE_COURSE.DETAILS.VIEW,
      ],
      route: OnlineCourseDetailsEditor,
    },
    {
      path: `${matchUrl}/batches`,
      title: 'Batches',
      private: true,
      exact: true,
      roles: [
        APP_PERMISSION.COMMON.ADMINISTRATOR,
        APP_PERMISSION.COMMON.MARKETER,
        APP_PERMISSION.ONLINE_COURSE.PRICING.VIEW,
      ],
      route: OnlineCourseBatchesEditor,
    },
    {
      path: `${matchUrl}/table-of-contents`,
      title: 'Table Of Contents',
      private: true,
      exact: true,
      roles: [
        APP_PERMISSION.COMMON.ADMINISTRATOR,
        APP_PERMISSION.COMMON.MARKETER,
        APP_PERMISSION.ONLINE_COURSE.TABLE_OF_CONTENTS.VIEW,
      ],
      // TODO: implement route: OnlineCourseTableOfContentEditor when clear instructions
      route: OnlineCourseTableOfContentEditor,
    },
    {
      path: `${matchUrl}/highlights`,
      title: 'Highlights',
      private: true,
      exact: true,
      roles: [
        APP_PERMISSION.COMMON.ADMINISTRATOR,
        APP_PERMISSION.COMMON.MARKETER,
        APP_PERMISSION.ONLINE_COURSE.HIGHLIGHTS.VIEW,
      ],
      route: OnlineCourseHighlightEditor,
    },
    {
      path: `${matchUrl}/faq`,
      title: 'FAQs',
      private: true,
      exact: true,
      roles: [
        APP_PERMISSION.COMMON.ADMINISTRATOR,
        APP_PERMISSION.COMMON.MARKETER,
        APP_PERMISSION.ONLINE_COURSE.FAQ.VIEW,
      ],
      route: OnlineCourseFAQEditor,
    },
    {
      path: `${matchUrl}/ratings`,
      title: 'Ratings',
      private: true,
      exact: true,
      roles: [APP_PERMISSION.COMMON.ADMINISTRATOR, APP_PERMISSION.ONLINE_COURSE.RATINGS.VIEW],
      route: OnlineCourseRatingEditor,
    },
  ];

  return menus;
};
const OnlineCourseDetails = withTheme((props) => {
  const { collectionOnlineCourse, match, theme } = props;
  const { productPreview } = getConfig();

  return (
    <Fragment>
      <Container
        fluid
        style={{
          backgroundColor: theme.colors.primary,
        }}
      >
        <Container>
          <OnlineCourseBatchHeader {...collectionOnlineCourse} />
        </Container>
        {productPreview?.enabledProductPreview && (
          <Flex justifyContent="flex-end" width="100%" pr={2} pb={3}>
            <ProductPreviewButton
              platformURL={productPreview.platformURL}
              permalink={collectionOnlineCourse.permalink}
            />
          </Flex>
        )}
      </Container>
      <Divider hidden />
      <Menu menus={genMenu(match.url)} menuProps={{ secondary: true, pointing: true }} />
      <GenRoute menus={genMenu(match.path)} onlineCourse={collectionOnlineCourse} />
    </Fragment>
  );
});

export default OnlineCourseDetails;
